import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getPartnerProduct } from "../../functions";
import Loading from "../../../atoms/loading";
import PartnerUserInfo from "./partnerUserInfo";
import PartnerProductSerials from "./partnerProductSerials";
import PartnerProductInfo from "./partnerProductInfo";
import PartnerProductComments from "./partnerProductComments";

const PartnerProduct = ({ user }) => {

    const { id } = useParams();

    const [productData, setProductData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        doGetProduct();
        // eslint-disable-next-line
    }, [])

    const doGetProduct = async () => {
        setLoading(true);
        const data = await getPartnerProduct(user?.token, id);
        if (data?.type !== "success") {
            setError(true);
            setLoading(false);
            return null;
        }
        setProductData(data?.data);
        setLoading(false);
    }

    if (error) {
        return (
            <main>
                <h1 className="border-b border-primary text-center">Pedido</h1>
                <p className="text-center text-red-500 mt-4">Erro ao obter dados do pedido</p>
            </main>
        )
    }

    if (loading) {
        return (
            <main>
                <h1 className="border-b border-primary text-center">Pedido</h1>
                <div className="m-auto w-fit mt-10">
                    <Loading />
                </div>
            </main>
        )
    }
    return (
        <main className="mb-10">
            <h1 className="border-b border-primary text-center text-lg font-bold">Pedido</h1>
            <div>
                <div className="relative">
                    <PartnerUserInfo userData={productData?.user} />
                </div>
                <PartnerProductComments productData={productData} refresh={doGetProduct} />
                <PartnerProductInfo user={user} refresh={doGetProduct} productData={productData} stores={null} />
                <PartnerProductSerials user={user} productData={productData} setProductData={setProductData} />
            </div>
        </main>
    )
}

export default PartnerProduct;
